import login from './login'
import register from './register'
import changePassword from './changePassword'

const zhCN = {
  userLogin: login.zhCN,
  userRegister: register.zhCN,
  userChangePassword: changePassword.zhCN
}
const enUS = {
  userLogin: login.enUS,
  userRegister: register.enUS,
  userChangePassword: changePassword.enUS
}
export default { zhCN, enUS }